import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth, RequireStaff } from './auth/guards.js';
import { Layout } from './components/Layout.js';
import { LoginPage } from './pages/LoginPage.js';
import { AcceptInvitePage } from './pages/AcceptInvitePage.js';
import { ChangePasswordPage } from './pages/ChangePasswordPage.js';
import { ProjectsPage } from './pages/ProjectsPage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { MembershipPage } from './pages/MembershipPage.js';
import { ProjectShell, ProjectIndexRedirect } from './pages/project/ProjectShell.js';
import { QuestionnairePage } from './pages/project/QuestionnairePage.js';
import { SpecificationPage } from './pages/project/SpecificationPage.js';
import { RepositoryPage } from './pages/project/RepositoryPage.js';
import { LiveTestingPage } from './pages/project/LiveTestingPage.js';
import { StoriesPage } from './pages/project/StoriesPage.js';
import { MessagesPage } from './pages/project/MessagesPage.js';
import { BoardPage } from './pages/project/BoardPage.js';
import { GuidePage } from './pages/project/GuidePage.js';
import { DashboardPage } from './pages/project/DashboardPage.js';
import { SubmissionsPage } from './pages/console/SubmissionsPage.js';
import { MonitorPage } from './pages/console/MonitorPage.js';
import { PeoplePage } from './pages/console/PeoplePage.js';
import { UsersPage } from './pages/console/UsersPage.js';
import { TiersPage } from './pages/console/TiersPage.js';
import { SecretsPage } from './pages/console/SecretsPage.js';
import { AdminProjectPage } from './pages/console/AdminProjectPage.js';
import { BuildConsolePage } from './pages/console/BuildConsolePage.js';
import { AuditPage } from './pages/console/AuditPage.js';
import { GlobalDebugPage } from './pages/console/GlobalDebugPage.js';

/** The route tree. Rendered inside a Router + QueryClientProvider (see main.tsx). */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />

      <Route element={<RequireAuth />}>
        {/* Reachable even while a password change is pending (ADR-009). */}
        <Route path="/change-password" element={<ChangePasswordPage />} />

        <Route element={<Layout />}>
          <Route path="/" element={<ProjectsPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/settings" element={<SettingsPage />} />

          {/* Founder project workspace: stepper + the current stage. */}
          <Route path="/projects/:id" element={<ProjectShell />}>
            <Route index element={<ProjectIndexRedirect />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="questionnaire" element={<QuestionnairePage />} />
            <Route path="specification" element={<SpecificationPage />} />
            <Route path="repository" element={<RepositoryPage />} />
            <Route path="livetest" element={<LiveTestingPage />} />
            <Route path="stories" element={<StoriesPage />} />
            <Route path="board" element={<BoardPage />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="guide" element={<GuidePage />} />
          </Route>

          <Route element={<RequireStaff />}>
            <Route path="/console" element={<SubmissionsPage />} />
            <Route path="/console/monitor" element={<MonitorPage />} />
            <Route path="/console/people" element={<PeoplePage />} />
            <Route path="/console/users" element={<UsersPage />} />
            <Route path="/console/tiers" element={<TiersPage />} />
            <Route path="/console/secrets" element={<SecretsPage />} />
            <Route path="/console/projects/:id" element={<AdminProjectPage />} />
            <Route path="/console/builds/:projectId/:buildId" element={<BuildConsolePage />} />
            <Route path="/console/audit" element={<AuditPage />} />
            <Route path="/console/debug" element={<GlobalDebugPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
